export default __webpack_public_path__ + "static/media/legal-team-defendant2.d12759d5.png";